<template>
  <div class="xv_view" id="Dashboard_G">
    <!-- Unread Alerts -->
    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Unread Alerts</span>
        </div>
        <div></div>
      </div>
      <table class="unread_table">
        <thead>
          <tr>
            <th style="width:15%">Message type</th>
            <th style="width:15%;text-align:center">Building</th>
            <th style="width:20%;text-align:center">Date/Time</th>
            <th style="width:50%;text-align:center">Message</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Vestibulum</td>
            <td>Scelerisque</td>
            <td>02-Jan-2020 10:30am</td>
            <td>
              Fusce placerat nec metus eget semper. Vivamus posuere sapien enim,
              non pulvinar nibh lacinia luctus.Fusce placerat nec metus eget
              semper.
            </td>
          </tr>
          <tr>
            <td>Suspendisse</td>
            <td>Elementum</td>
            <td>02-Jan-2020 10:30am</td>
            <td>
              Ut eu sapien ac diam vulputate euismod id ut nibh. Sed laoreet
              viverra augue at molestie.Fusce placerat nec metus eget semper.
            </td>
          </tr>
          <tr>
            <td>Bibendum</td>
            <td>Malesuada</td>
            <td>02-Jan-2020 10:30am</td>
            <td>
              Pellentesque suscipit convallis egestas. Proin eu velit eu tellus
              malesuada cursus.vulputate euismod id ut nibh. Sed laoreet
              viverra.
            </td>
          </tr>
          <tr>
            <td>Sapien</td>
            <td>Ullamcorper</td>
            <td>02-Jan-2020 10:30am</td>
            <td>
              Nam semper orci vel nulla euismod fringilla. Duis egestas, erat at
              dictum aliquet. Vivamus posuere sapien enim, non pulvinar .
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-6">
        <!-- Traffic in the building today -->
        <div class="xv_table">
          <div class="xv_table_title">
            <div>
              <span>Traffic in the building today</span>
            </div>
            <div></div>
          </div>
          <table class="traffic_table">
            <thead>
              <tr>
                <th style="width:15%;">Building</th>
                <th style="width:17%;text-align:center">08-10am</th>
                <th style="width:17%;text-align:center">10-12pm</th>
                <th style="width:17%;text-align:center">12-02pm</th>
                <th style="width:17%;text-align:center">02-04pm</th>
                <th style="width:17%;text-align:center">04-06pm</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Selerisque</td>
                <td>10</td>
                <td>13</td>
                <td>09</td>
                <td>24</td>
                <td>11</td>
              </tr>
              <tr>
                <td>Malesuada</td>
                <td>09</td>
                <td>14</td>
                <td>13</td>
                <td>11</td>
                <td>20</td>
              </tr>
              <tr>
                <td>Elementum</td>
                <td>20</td>
                <td>09</td>
                <td>13</td>
                <td>14</td>
                <td>11</td>
              </tr>
              <tr>
                <td>Ullamcorper</td>
                <td>13</td>
                <td>20</td>
                <td>14</td>
                <td>11</td>
                <td>09</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-6">
        <!-- Teams -->
        <div class="xv_table">
          <div class="xv_table_title">
            <div>
              <span>Teams</span>
            </div>
            <div></div>
          </div>
          <table class="teams_table">
            <thead>
              <tr>
                <th style="width:15%">Building</th>
                <th style="width:15%;text-align:center">Attendantds</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Malesuada</td>
                <td>14</td>
              </tr>
              <tr>
                <td>Selerisque</td>
                <td>20</td>
              </tr>
              <tr>
                <td>Ullamcorper</td>
                <td>08</td>
              </tr>
              <tr>
                <td>Elementum</td>
                <td>12</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dashboard_G",
  data() {
    return {};
  }
};
</script>
